module.exports = __webpack_public_path__ + "img/veggiefolks.1f232ad4.jpg";